import { type Common } from './common.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';
import {
  type BasePracticeGroup,
  type FindAllOptions,
  type PracticeGroup,
} from './models/practiceGroup.js';

export class API {
  common: Common;
  baseEndpoint = '/practice-groups';

  constructor(common: Common) {
    this.common = common;
  }

  async create(toAdd: BasePracticeGroup): Promise<PracticeGroup> {
    const url = this.common.constructPath(this.baseEndpoint);
    const { practiceGroup } = await this.common.postJSON(url, toAdd);
    return practiceGroup;
  }

  async findAll(query: FindAllOptions = {}): Promise<PracticeGroup[]> {
    const url = this.common.constructPath(this.baseEndpoint, query);
    const { practiceGroups } = await this.common.getJSON(url);
    return practiceGroups;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<PracticeGroup>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PracticeGroup> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { practiceGroup } = await this.common.getJSON(url);
    return practiceGroup;
  }

  async update(id: string, values: BasePracticeGroup): Promise<PracticeGroup> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { practiceGroup } = await this.common.patchJSON(url, values);
    return practiceGroup;
  }
}
